<template>
  <div class="my-3">
    <b-row v-if="data">
      <b-col>
        <b-row>
          <b-col cols="12">
            <b-row>
              <b-col cols="12">
                <table class="min-w-full leading-normal mt-1 text-gray"
                       style="border: solid 1px #dedede;">
                  <thead>
                  <tr class="bg-gray-pale">
                    <td colspan="12" class="px-2 py-2 font-bold">Application Details</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr style="border: solid 1px #dedede;">
                    <td class="px-2 py-1 text-capitalize font-bold">Type of Application</td>
                    <td class="px-2 py-1">{{ na(data.type) ? cleanUnderscores(data.type) : '—' }}</td>
                  </tr>
                  <tr style="border: solid 1px #dedede;">
                    <td class="px-2 py-1 text-capitalize font-bold">Nature of application</td>
                    <td class="px-2 py-1">{{ na(data.natureOfDispute) ? cleanUnderscores(data.natureOfDispute) : '—' }}</td>
                  </tr>
                  <tr style="border: solid 1px #dedede;">
                    <td class="px-2 py-1 text-capitalize font-bold">Subject Entity</td>
                    <td class="px-2 py-1">{{ na(data.subjectEntity) ? data.subjectEntity : '—' }}</td>
                  </tr>
                  <tr style="border: solid 1px #dedede;">
                    <td class="px-2 py-1 text-capitalize font-bold">Subject Entity BRN</td>
                    <td class="px-2 py-1">{{ na(data.subjectEntityBrn) ? data.subjectEntityBrn : '—' }}</td>
                  </tr>
                  <tr style="border: solid 1px #dedede;">
                    <td class="px-2 py-1 text-capitalize font-bold">Tracking No.</td>
                    <td class="px-2 py-1">{{ na(data.trackingNo) ? data.trackingNo : '—' }}</td>
                  </tr>
                  <tr style="border: solid 1px #dedede;">
                    <td class="px-2 py-1 text-capitalize font-bold">Status</td>
                    <td class="px-2 py-1">{{ na(data.status) ? cleanUnderscores(data.status) : '—' }}</td>
                  </tr>
                  <tr style="border: solid 1px #dedede;">
                    <td class="px-2 py-1 text-capitalize font-bold">Description</td>
                    <td class="px-2 py-1">{{ na(data.description) ? data.description : '—' }}</td>
                  </tr>
                  <tr style="border: solid 1px #dedede;">
                    <td class="px-2 py-1 text-capitalize font-bold">Cause No.</td>
                    <td class="px-2 py-1">{{ na(data.causeNo) ? data.causeNo : '—' }}</td>
                  </tr>
                  <tr style="border: solid 1px #dedede;">
                    <td class="px-2 py-1 text-capitalize font-bold">Year</td>
                    <td class="px-2 py-1">{{ data != null && data.year != null ? data.year : '—' }}</td>
                  </tr>
                  <tr style="border: solid 1px #dedede;">
                    <td class="px-2 py-1 text-capitalize font-bold">Submission Date</td>
                    <td class="px-2 py-1">{{ na(data.submissionDate) ? dateFormat(data.submissionDate) : '—' }}</td>
                  </tr>
                  <tr v-if="na(data.registrarName)" style="border: solid 1px #dedede;">
                    <td class="px-2 py-1 text-capitalize font-bold">Registrar</td>
                    <td class="px-2 py-1">{{ data.registrarName }}</td>
                  </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>

            <b-row class="mt-2" v-if="data && data.corporateSubjectEntity">
              <b-col cols="12">
                <table class="min-w-full leading-normal text-gray"
                       style="border: solid 1px #dedede;">
                  <thead>
                  <tr class="bg-gray-pale">
                    <td colspan="12" class="px-2 py-2 font-bold">Corporate Subject Entity</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr style="border: solid 1px #dedede;">
                    <td class="px-2 py-1">
                      <LegalPersons class="p-1"
                                    :persons="[{entityType:'CORPORATE', corporate: data.corporateSubjectEntity}]"/>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>

            <b-row class="mt-2" v-if="showComplainants && data && data.complainants && data.complainants.length">
              <b-col cols="12">
                <table class="min-w-full leading-normal text-gray" style="border: solid 1px #dedede;">
                  <thead>
                  <tr class="bg-gray-pale">
                    <td colspan="12" class="px-2 py-2 font-bold">Complainants</td>
                  </tr>
                  </thead>
                  <tbody>
                  <LegalPersons class="p-1" :persons="data.complainants"/>
                  </tbody>
                </table>
              </b-col>
            </b-row>

            <b-row v-if="showRespondents && data && data.respondents && data.respondents.length" class="mt-2">
              <b-col cols="12">
                <table class="min-w-full leading-normal text-gray" style="border: solid 1px #dedede;">
                  <thead>
                  <tr class="bg-gray-pale">
                    <td colspan="12" class="px-2 py-2 font-bold">Respondents</td>
                  </tr>
                  </thead>
                  <tbody>
                  <LegalPersons class="p-1" :persons="data.respondents"/>
                  </tbody>
                </table>
              </b-col>
            </b-row>

            <b-row class="mt-2" v-if="data && data.addressOfService">
              <b-col cols="12">
                <table class="min-w-full leading-normal mt-1 text-gray"
                       style="border: solid 1px #dedede;">
                  <thead>
                  <tr class="bg-gray-pale">
                    <td colspan="12" class="px-2 py-2 font-bold">Address of service</td>
                  </tr>
                  </thead>
                  <tbody>
                  <b-row class="mx-1 py-1">
                    <b-col>
                      <b-form-group v-if="data.addressOfService.village && data.addressOfService.village.region"
                                    class="text-sm my-1" label="Region" label-for="input-1">
                        <b-form-input class="form-text text-sm noFocus" type="text" :disabled="true"
                                      :value="data.addressOfService.village.region ? data.addressOfService.village.region.name : ''"/>
                      </b-form-group>
                      <b-form-group v-if="data.addressOfService.village && data.addressOfService.village.district"
                                    class="text-sm my-1" label="District" label-for="input-1">
                        <b-form-input class="form-text text-sm noFocus text-capitalize" type="text" :disabled="true"
                                      :value="data.addressOfService.village.district.name"/>
                      </b-form-group>
                      <b-form-group v-if="data.addressOfService.village && data.addressOfService.village.subcounty"
                                    class="text-sm my-1" label="Sub County" label-for="input-1">
                        <b-form-input class="form-text text-sm noFocus" type="text" :disabled="true"
                                      :value="data.addressOfService.village.subcounty.name"/>
                      </b-form-group>
                    </b-col>
                    <b-col>
                      <b-form-group v-if="data.addressOfService.village && data.addressOfService.village.parish"
                                    class="text-sm my-1" label="Parish" label-for="input-1">
                        <b-form-input class="form-text text-sm noFocus" type="text" :disabled="true"
                                      :value="data.addressOfService.village.parish.name"/>
                      </b-form-group>
                      <b-form-group v-if="data.addressOfService.village && data.addressOfService.village.village"
                                    class="text-sm my-1" label="Village" label-for="input-1">
                        <b-form-input class="form-text text-sm noFocus" type="text" :disabled="true"
                                      :value="data.addressOfService.village.village.name"/>
                      </b-form-group>
                      <b-form-group v-if="data.addressOfService.address"
                                    class="text-sm my-1" label="Street" label-for="input-1">
                        <b-form-input class="form-text text-sm noFocus" type="text" :disabled="true"
                                      :value="data.addressOfService.address.street || '—'"/>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  </tbody>
                </table>
              </b-col>
            </b-row>

            <b-row v-if="data && data.facts && data.facts.length" class="my-1">
              <b-col>
                <table class="min-w-full leading-normal mt-1 text-gray"
                       style="border: solid 1px #dedede;">
                  <thead>
                  <tr class="bg-gray-pale">
                    <td colspan="12" class="px-2 py-2 font-bold">Facts</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr style="border: solid 1px #dedede;" v-for="(fact,idx) in data.facts" :key="idx">
                    <td class="px-2 py-1">{{ fact && fact.description ? fact.description : '—' }}</td>
                  </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>

            <b-row v-if="data && data.prayer" class="my-1">
              <b-col>
                <table class="min-w-full leading-normal mt-1 text-gray"
                       style="border: solid 1px #dedede;">
                  <thead>
                  <tr class="bg-gray-pale">
                    <td colspan="12" class="px-2 py-2 font-bold">Prayer/ Relief being sought</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr style="border: solid 1px #dedede;">
                    <td class="px-2 py-1">{{ data.prayer }}</td>
                  </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>

            <b-row class="mt-2" v-if="data && data.officialAccount">
              <b-col cols="12">
                <table class="min-w-full leading-normal mt-1 text-gray"
                       style="border: solid 1px #dedede;">
                  <thead>
                  <tr class="bg-gray-pale">
                    <td colspan="12" class="px-2 py-2 font-bold">Official Account Details Update</td>
                  </tr>
                  </thead>
                  <tbody>
                  <b-row class="mx-1 py-1">
                    <b-col>
                      <b-form-group class="text-sm my-1 text-gray" label="Old Email" label-for="input-1">
                        <b-form-input class="form-text text-sm noFocus" type="text" :disabled="true"
                                      :value="data.officialAccount.oldEmail || '—'"/>
                      </b-form-group>
                      <b-form-group class="text-sm my-1 text-gray" label="Old Phone" label-for="input-1">
                        <b-form-input class="form-text text-sm noFocus" type="text" :disabled="true"
                                      :value="data.officialAccount.oldPhone || '—'"/>
                      </b-form-group>
                    </b-col>
                    <b-col>
                      <b-form-group class="text-sm my-1 text-gray" label="New Email" label-for="input-1">
                        <b-form-input class="form-text text-sm noFocus" type="text" :disabled="true"
                                      :value="data.officialAccount.newEmail || '—'"/>
                      </b-form-group>
                      <b-form-group class="text-sm my-1 text-gray" label="New Phone" label-for="input-1">
                        <b-form-input class="form-text text-sm noFocus" type="text" :disabled="true"
                                      :value="data.officialAccount.newPhone || '—'"/>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  </tbody>
                </table>
              </b-col>
            </b-row>

            <b-row class="mt-2" v-if="data && data.payment">
              <b-col cols="12">
                <table class="min-w-full leading-normal mt-1 text-gray"
                       style="border: solid 1px #dedede;">
                  <thead>
                  <tr class="bg-gray-pale">
                    <td colspan="12" class="px-2 py-2 font-bold">Payment</td>
                  </tr>
                  </thead>
                  <tbody>
                  <tr style="border: solid 1px #dedede;">
                    <td class="px-2 py-1 font-bold">PRN</td>
                    <td class="px-2 py-1">{{ data.payment.prn || '—' }}</td>
                  </tr>
                  <tr style="border: solid 1px #dedede;">
                    <td class="px-2 py-1 font-bold">Status</td>
                    <td class="px-2 py-1">{{ data.payment.status || '—' }}</td>
                  </tr>
                  <tr v-if="data.payment.amount" style="border: solid 1px #dedede;">
                    <td class="px-2 py-1 font-bold">Amount</td>
                    <td class="px-2 py-1">{{ data.payment.amount.parsedValue != null ? data.payment.amount.parsedValue : (data.payment.amount.source || '—') }}</td>
                  </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>

            <b-row class="mt-2" v-if="data && data.applicant">
              <b-col cols="12">
                <table class="min-w-full leading-normal mt-1 text-blue-dark"
                       style="border: solid 1px #bdd7f1;">
                  <thead>
                  <tr class="bg-blue-pale">
                    <td colspan="12" class="px-2 py-2 font-bold">Applicant Details</td>
                  </tr>
                  <tr>
                    <th class="px-2 py-1">Name</th>
                    <th class="px-2 py-1">Email</th>
                    <th class="px-2 py-1">Phone</th>
                    <th class="px-2 py-1">NIN</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr style="border: solid 1px #bdd7f1;">
                    <td class="px-2 py-1 text-capitalize">
                      {{ [data.applicant.givenName, data.applicant.middleName, data.applicant.surname].filter(Boolean).join(' ') || '—' }}
                    </td>
                    <td class="px-2 py-1">{{ data.applicant.email || '—' }}</td>
                    <td class="px-2 py-1">{{ data.applicant.phoneNumber || '—' }}</td>
                    <td class="px-2 py-1">{{ data.applicant.nin || '—' }}</td>
                  </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from "moment";
import LegalPersons from "@/views/home/commons/LegalPersons.vue";

export default {
  name: "DisputeResolutionFormDetailsEscalated",
  components: {
    LegalPersons
  },
  props: {
    task: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      attachmentUrl: null,
      individualDirectors: [],
      corporateDirectors: [],
      individualSecretary: null,
      corporateSecretary: null,
      adoptionTableText: null,
      oldContacts: {
        email: null,
        phone: null,
      }
    }
  },

  computed: {
    data() {
      if (!this.task) return null;
      return this.task.data != null ? this.task.data : this.task;
    },
    showComplainants() {
      if (!this.data) return false;
      const type = this.data.type;
      return type != null && type !== "OFFICIAL_ACCOUNT";
    },
    showRespondents() {
      if (!this.data) return false;
      const type = this.data.type;
      return type != null && type !== "OFFICIAL_ACCOUNT";
    }
  },

  methods: {
    dateFormat(date) {
      if (date) return moment(date).format("DD-MM-YYYY");
      return "—";
    },
    na(val) {
      return val != null && val !== "";
    },
    cleanUnderscores(name) {
      if (name == null || name === "") return "—";
      let n = String(name).replaceAll("_", " ");
      return n.charAt(0).toUpperCase() + n.slice(1);
    },
    cleanName(name) {
      if (name) {
        let n = name.replaceAll("_", " ");
        return n.toLowerCase();
      }
      return "N/A";
    },
    filingName(name) {
      if (!name) return "—";
      if (name === "APPEND_INFORMATION") return "#resolution";
      return "#" + name.replaceAll("_", "").toLowerCase();
    }
  },
}
</script>

<style scoped>
th, td {
  font-size: 12px;
}
</style>
